import { FC, useMemo } from 'react';
import { useQuery } from 'urql';
import { MedicalInstitutionTop } from '~/components/features/medical-institution/MedicalInstitutionTop/MedicalInstitutionTop';
import { MedicalInstitutionTopByIdDocument } from 'gen/medinavi-backend-consumer-graphql/graphql';
import { HandledError } from '~/types/handled-error';
import { medicalInstitutionIdKeyMap } from '~/constants/medicalInstitutionIdKeyMap';

type Props = {
  hospitalUserId: number;
};

export const MedicalInstitutionTopById: FC<Props> = ({ hospitalUserId }) => {
  const [institution] = useQuery({
    query: MedicalInstitutionTopByIdDocument,
    variables: {
      facilityMemberId: hospitalUserId,
    },
  });

  const canonicalUrl = useMemo(() => {
    const url = new URL('/medical_institution/introduction', process.env.NEXT_PUBLIC_MEDICO_URL as string);

    const predefinedMedicalInstitution = medicalInstitutionIdKeyMap.find(
      (i) => i.hospital_user_id === hospitalUserId.toString(),
    );
    if (predefinedMedicalInstitution) {
      url.searchParams.set('hospital_user_key', predefinedMedicalInstitution.key);
    } else {
      url.searchParams.set('hospital_user_id', hospitalUserId.toString());
    }

    return url.toString();
  }, [hospitalUserId]);

  if (institution?.data?.medicoFacilityByFacilityMemberId == null) {
    // TODO captureしなくて良い？？
    throw new HandledError(new Error('medicoFacilityByFacilityMemberId must be non-null'), {
      shouldSendToSentry: false,
      requireReStart: false,
    });
  }

  return (
    <MedicalInstitutionTop
      keyOrId={`${hospitalUserId}`}
      canonicalUrl={canonicalUrl}
      institution={institution.data.medicoFacilityByFacilityMemberId}
    />
  );
};
